// C28 1.14.4 · paginado solo cuando hay más de una página (decisión del dueño D10). La misma regla en Etiquetas y en
// Contactos: con todo dentro de la opción más chica no hay paginado (el total ya está arriba); con más filas pero una
// sola página, solo «Por página»; con más de una página, el paginado completo. Nunca «1–1 de 1» ni un «1» solo.

export type PagerMode = "none" | "size" | "full";

/** Qué parte del paginado se muestra para `total` filas con `pageSize` por página. */
export function pagerMode(total: number, pageSize: number, smallest = 10): PagerMode {
  if (total <= smallest) return "none";
  return Math.ceil(total / pageSize) <= 1 ? "size" : "full";
}
